

const MessageConversationCard = ({
  name, uid, phoneNumber, lastMessage, sentTime,
  onClick
}) =>
{

  return (
    <div className="message-contact-card" data-id={ uid }
      onClick={ onClick }>
      <div className="message-contact-head">
        <strong className="contact-name">{ name }</strong>
        <span className="phone-number">{ phoneNumber }</span>
      </div>
      <div className="last-message">{ lastMessage }</div>
      <div className="timestamp">{ sentTime }</div>
    </div>
  )
}

export default MessageConversationCard
